import { Observable } from "rxjs/internal/Observable";
import { catchError, map } from "rxjs/operators";
import { API_URL } from "../../enums/api.enums";
import HttpClient from "../http-client";
import Utils from "../../utils/base-utils";
import { ICategory, ICategoryRequest } from "../../common/category.interface";

export default class CategoryApi {
    static apiURL = API_URL;

    // GET /category - Lấy tất cả categories
    static getListCategory(): Observable<any> {
        const api = `${CategoryApi.apiURL.HOST}/category`;
        return HttpClient.get(api).pipe(
            map((res) => (res as any) || null),
            catchError((error) => {
                console.error('Error fetching categories:', error);
                return new Observable();
            })
        );
    }

    // POST /category - Tạo category mới
    static addCategory(body: ICategoryRequest): Observable<any> {
        const api = `${CategoryApi.apiURL.HOST}/category`;
        const requestBody = {
            name: body.name,
            ...(body.description && { description: body.description })
        };
        
        console.log('Adding category:', requestBody);
        return HttpClient.post(api, requestBody).pipe(
            map((res) => (res as any) || null),
            catchError((error) => {
                console.error('Error adding category:', error);
                return new Observable();
            })
        );
    }

    // Alias for getListCategory to maintain backward compatibility
    static getCategories(): Observable<any> {
        return this.getListCategory();
    }

    // Legacy method - will be updated when edit/delete APIs are available
    static editCategory(bodyrequest: any): Observable<any> {
        const finalBodyrequest = {
            name: bodyrequest.name,
            ...(bodyrequest.description !== undefined && { description: bodyrequest.description })
        };
        
        console.log('Editing category:', finalBodyrequest);
        const api = `${CategoryApi.apiURL.HOST}/${this.apiURL.EDIT_CATEGORY}/${bodyrequest.id}`;
        return HttpClient.put(api, finalBodyrequest).pipe(
            map((res) => (res as any) || null),
            catchError((error) => {
                console.error('Error editing category:', error);
                return new Observable();
            })
        );
    }

    // Legacy method - will be updated when delete API is available
    static deleteCategory(bodyrequest: any): Observable<any> {
        const api = `${CategoryApi.apiURL.HOST}/${this.apiURL.DELETE_CATEGORY}/${bodyrequest.id}`;
        return HttpClient.delete(api).pipe(
            map((res) => (res as any) || null),
            catchError((error) => {
                console.error('Error deleting category:', error);
                return new Observable();
            })
        );
    }
}